import { AfterViewInit, Component, ElementRef, NgZone, OnInit } from '@angular/core';
import { Tabs } from '@enums/tab.enum';
import { ProductItemType } from '@fs/enums/common-enums';
import { Grid } from '@fs/enums/grid.enum';
import { customJS } from '@fs/services/customjs';
import { GridFilter } from '@fs/services/grid.mixin';
import { PriceBookService } from '@fs/services/price-book/price-book.service';
import { TabOpenService } from '@services/tab-open.service';
import { ExportType } from "@fs/enums/common-enums";
import { PermissionPipe } from '@shared/pipes/permission.pipe';
import { ExportService } from '@shared/services/export.service';
import { SpinnerService } from '@shared/services/spinner.service';
import { of } from 'rxjs';
import { catchError, debounceTime, switchMap, takeUntil } from 'rxjs/operators';
import { ExportColumnHeaders } from '@shared/models/export-headers.model';
import { MapExportData } from '@shared/data/MapExportData';
import { ActionName } from '@shared/enums/action-name';
import { Constants } from '@constants';

@Component({
  selector: 'pb-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class PbListComponent extends GridFilter implements OnInit, AfterViewInit {
  productItemType = ProductItemType;
  
  public defaultImage: string = Constants.DefaultImagePaths.Category;  
  
  constructor(private $elementRef: ElementRef, private priceBookServ: PriceBookService, private exportServ: ExportService,
              private tabopen: TabOpenService, private zone: NgZone, spinnerServ: SpinnerService, private permissionPipe: PermissionPipe) { 
    super(Grid.Product, spinnerServ);
    //ToDo: Optimizing further requires significant changes in the exisitng services
    this.makeRequest$.pipe(
      debounceTime(Constants.debounceInterval),
      switchMap((val:string) => 
        this.priceBookServ.GetPriceBookItems(this.isExport? this.getExportState() : this.state, val).pipe(
          catchError(() => {
            return of({ Data: [], Count: 0 });
          })
      )), 
      takeUntil(this.ngUnsubscribe))
      .subscribe(r => {
        this.spinnerServ.hideLoader(this.gridVc, this.tabCounter);
        if (!this.isExport) this.mapGridData(r); else this.mapExportData(r); 
      });
  }

  ngOnInit() {
    this.spinnerServ.showloader(this.gridVc, this.tabCounter, Constants.defaultSpinnertimeout, true);
    this.getData();
  }
  ngAfterViewInit() {
    this.zone.runOutsideAngular(() => {
      customJS.setScroll(this.$elementRef.nativeElement);
    });
  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  openEditItem(ItemID: string, type: string, ItemNumber: string) {
    if (!this.permissionPipe.transform(ActionName.EditItem)) {
      return
    }
    switch (type) {
      case "Labor":
        this.tabopen.OpenTab(
          {
            tabId: Tabs.FsLiteLaborItemEdit,
            params: { ID: ItemID },
            tabTitle: type + ' - ' + ItemNumber,
            replaceIfOpen: { replaceTab: true, tabToReplace: Tabs.FsLiteLaborItemDetail, action: "replace" }
          })
        break;
      case "Material":
        this.tabopen.OpenTab(
          {
            tabId: Tabs.FsLiteMaterialItemEdit,
            params: { ID: ItemID },
            tabTitle: type + ' - ' + ItemNumber,
            replaceIfOpen: { replaceTab: true, tabToReplace: Tabs.FsLiteMaterialItemDetail, action: "replace" }
          })
        break;
      case "Service":
        this.tabopen.OpenTab(
          {
            tabId: Tabs.FsLiteServiceItemEdit,
            params: { ID: ItemID },
            tabTitle: type + ' - ' + ItemNumber,
            replaceIfOpen: { replaceTab: true, tabToReplace: Tabs.FsLiteServiceItemView, action: "replace" }
          })
        break;
      case "Agreement":
        this.tabopen.OpenTab(
          {
            tabId: Tabs.FsLiteServiceAgreementItem,
            params: { ID: ItemID },
            tabTitle: type + ' - ' + ItemNumber,
            replaceIfOpen: { replaceTab: true, tabToReplace: Tabs.FsLiteServiceAgreementItemDetail, action: "replace" }
          })
        break;
      default:
        break;
    }
  }
  openViewItem(ItemID: string, type: string, ItemNumber: string) {
    switch (type) {
      case "Labor":
        this.tabopen.OpenTab(
          {
            tabId: Tabs.FsLiteLaborItemDetail,
            params: { ID: ItemID },
            tabTitle: type + ' - ' + ItemNumber,
            replaceIfOpen: { replaceTab: true, tabToReplace: Tabs.FsLiteLaborItemEdit, action: "focus" }
          })
        break;
      case "Material":
        this.tabopen.OpenTab(
          {
            tabId: Tabs.FsLiteMaterialItemDetail,
            params: { ID: ItemID },
            tabTitle: type + ' - ' + ItemNumber,
            replaceIfOpen: { replaceTab: true, tabToReplace: Tabs.FsLiteMaterialItemEdit, action: "focus" }
          })
        break;
      case "Service":
        this.tabopen.OpenTab(
          {
            tabId: Tabs.FsLiteServiceItemView,
            params: { ID: ItemID },
            tabTitle: type + ' - ' + ItemNumber,
            replaceIfOpen: { replaceTab: true, tabToReplace: Tabs.FsLiteServiceItemEdit, action: "focus" }
          })
        break;
      case "Agreement":
        // ItemID = '20f3030b-fdbb-4c43-b123-099c2ad6374a';
        // ItemNumber = '9999';
        this.tabopen.OpenTab(
          {
            tabId: Tabs.FsLiteServiceAgreementItemDetail,
            params: { ID: ItemID },
            tabTitle: type + ' - ' + ItemNumber,
            replaceIfOpen: { replaceTab: true, tabToReplace: Tabs.FsLiteServiceAgreementItem, action: "focus" }
          })
        break;
      default:
        break;
    }
  }
  openServiceAgreementItem() {
    this.tabopen.OpenTab(
      {
        tabId: Tabs.FsLiteServiceAgreementItem,
        params: {},
        tabTitle: 'New Agreement'
      })
  }
  openLaborItemNew() {
    this.tabopen.OpenTab(
      {
        tabId: Tabs.FsLiteLaborItemCreate,
        params: {},
        tabTitle: 'New Labor'
      })
  }
  openMaterialItemNew() {
    this.tabopen.OpenTab(
      {
        tabId: Tabs.FsLiteMaterialItemCreate,
        params: {},
        tabTitle: 'New Material'
      })
  }
  openServiceItemNew() {
    this.tabopen.OpenTab(
      {
        tabId: Tabs.FsLiteServiceItemForm,
        params: {},
        tabTitle: 'New Service'
      })
  }
  applyFilter(filterSetting: { applyAdvanceFilter: boolean, advanceFilterActive: any } = { advanceFilterActive: true, applyAdvanceFilter: null }, isStateReset: boolean = false) {
    let filterValues = this.filterForm.controls['searchFilters'];
    let filters = jQuery.extend(true, {}, filterValues);
    filters.value.map(x => {
      if (x.field == "StandardPrice") { x.value = (x.value).toString() ; }
    });
    this.filter(filterSetting, filters);
  }
  //#region private methods 
  private async mapExportData(r) {
    this.isExport = false;
    if (this.exportType == ExportType.Excel) {
      this.exportServ.ExportToExcel({
        exportData: r.Data.map(x => MapExportData.mapProducts(x, this.exportType)),
        exportHeadersColumns: ExportColumnHeaders.ProductColumns,
        columnHeaderNotToBeIncluded: []
      });
    } else if (this.exportType == ExportType.PDF) {
      this.exportServ.ExportToPDF({
        exportData: r.Data.map(x => MapExportData.mapProducts(x, this.exportType)),
        exportHeadersColumns: ExportColumnHeaders.ProductColumns,
        columnHeaderNotToBeIncluded: []
      });
    } else if (this.exportType == ExportType.CSV) {
      this.exportServ.ExportToCSV({
        exportData: r.Data.map(x => MapExportData.mapProducts(x, this.exportType)),
        exportHeadersColumns: ExportColumnHeaders.ProductColumns,
        columnHeaderNotToBeIncluded: []
      });
    }
  }
  //#endregion
}
